const ContactPage = () => (
  <div className="p-8 text-center">
    <h2 className="text-3xl font-bold mb-4">Contact Us</h2>
    <p className="text-gray-600">Email: support@myapp.com</p>
  </div>
);

export default ContactPage;